function initFaq() {
  const faqWrappers = document.querySelectorAll(".faq_main");

  faqWrappers.forEach((wrapper) => {
    if (wrapper.dataset.faqInitialized) return;
    wrapper.dataset.faqInitialized = "true";

    const faqItems = wrapper.querySelectorAll(".faq_item");

    faqItems.forEach((item) => {
      const question = item.querySelector(".faq_item_que");
      const answer = item.querySelector(".faq_item_ans");

      if (!question || !answer) return;

      // Collapse all initially
      answer.style.height = "0px";

      // Prevent text selection on rapid clicking (double-click), but allow drag selection
      question.addEventListener("mousedown", (e) => {
        if (e.detail > 1) {
          e.preventDefault();
        }
      });

      question.addEventListener("click", () => {
        const isActive = question.classList.contains("active");

        // Close all inside this wrapper
        faqItems.forEach((otherItem) => {
          const otherQuestion = otherItem.querySelector(".faq_item_que");
          const otherAnswer = otherItem.querySelector(".faq_item_ans");
          if (!otherQuestion || !otherAnswer) return;

          otherQuestion.classList.remove("active");
          otherQuestion.setAttribute("aria-expanded", "false");
          otherAnswer.classList.remove("active");
          otherAnswer.style.height = "0px";
        });

        // Toggle current
        if (!isActive) {
          question.classList.add("active");
          question.setAttribute("aria-expanded", "true");
          answer.classList.add("active");
          answer.style.height = answer.scrollHeight + "px";
        }
      });
    });
  });
}

// Run immediately
initFaq();

// Run on Shopify theme editor section load
document.addEventListener("shopify:section:load", initFaq);